import apiService from '../service/ApiService';
import { INTERNAL_ROUTES } from '../static/Urls';
import { reportActionEvent } from '../tracking/tracking';

const reportingApiUrl = INTERNAL_ROUTES.API_PATH + '/api/pdfreport/';

const doOnSuccess = (response: ArrayBuffer | undefined) => {
  if (response) {
    reportActionEvent({
      pageTitle: 'pdf-section',
      name: 'pdf_report_download',
    });
  }
};

const fetchPdfReport = (apiKey: string): Promise<ArrayBuffer | undefined> => {
  return apiService.callGet<ArrayBuffer>(
    reportingApiUrl + apiKey,
    {
      withCredentials: true,
      responseType: 'arraybuffer',
      headers: {
        Accept: 'application/pdf',
      },
    },
    { doOnSuccess },
  );
};

const reportingApi = {
  fetch: fetchPdfReport,
};

export default reportingApi;
